const { AndesProvider } = require('@andes/context');

require('@pages/V2/views/DesktopView/desktop_view.scss');

const React = require('react');
const { hydrateRoot } = require('react-dom/client');
const DesktopView = require('@root/app/pages/V2/views/DesktopView/view');

const { locale, device } = window.__PRELOADED_STATE__;

hydrateRoot(
  document.getElementById('root-app'),
  <AndesProvider locale={locale} device={device}>
    <DesktopView {...window.__PRELOADED_STATE__} />
  </AndesProvider>,
);
